import http from './http';
import { accountApiPath } from '@/config/deutscheBankDemo';

export interface ChatListItem {
  id: number;
  title: string;
  account_id: number;
  sheet_id?: number | null;
}

export const chatsApi = {
  async list(
    accountId: string | number,
    options?: { token?: string; sheetId?: number }
  ): Promise<ChatListItem[]> {
    const params = options?.sheetId != null ? { sheet_id: options.sheetId } : undefined;
    const res = await http.get(
      accountApiPath(accountId, '/chats'),
      options?.token ? { headers: { Authorization: `Bearer ${options.token}` }, params } : { params }
    );
    return res.data as ChatListItem[];
  },

  async create(
    accountId: string | number,
    data: { title: string },
    token?: string
  ): Promise<ChatListItem> {
    const res = await http.post(
      accountApiPath(accountId, '/chats'),
      data,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    return res.data as ChatListItem;
  },

  async delete(accountId: string | number, chatId: string | number, token?: string): Promise<void> {
    await http.delete(
      accountApiPath(accountId, `/chats/${chatId}`),
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
  },
};

export default chatsApi;
